module.exports = __webpack_public_path__ + "static/media/pp_pending_text_icon.603f1287.svg";